import React, {Component} from 'react';
import {connect} from "react-redux";

import ColumnChart from "./components/columnChart"
import _ from "lodash";
import axios from "axios/index";

import Select from "../common/select";
import './styles.scss';
import urls from "../../../utils/urls";
import {tokenHeader} from "../../../utils/headers";
import {ajaxHandler} from "../../../utils/errors";
import LoadingSpinner from "../../../components/spinner/Spinner";
import Table from "../table";

const months = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];
const values = [{label: "Últimos 6 meses", value: 5}, {label: "Últimos 12 meses", value: 11}];


class SLPPerFuel extends Component {


    constructor(props) {
        super(props);
        this.state = {
            selectedValue: values[0],
            data: false,
            xhr: false,
            axiosSource: null,
        }
    }

    onValueChange = (ev) => {
        this.setState({selectedValue: ev.target.value, data: false}, this._fetchData)
    };

    componentDidMount() {
        this._fetchData();
    };

    componentWillReceiveProps(nextProps) {
        if (nextProps.stations.list) {
            if ((nextProps.navigation.selectedArea !== this.props.navigation.selectedArea) ||
            (nextProps.navigation.selectedZone !== this.props.navigation.selectedZone) ||
            (nextProps.navigation.selectedStation !== this.props.navigation.selectedStation)) {
            this.setState({
                data: false
            }, this._fetchData);
        }}
    }

    _fetchData = () => {
        if (this.state.xhr) {
            this.state.axiosSource.cancel('abort');
        }
        const CancelToken = axios.CancelToken;
        const source = CancelToken.source();

        this.setState({xhr: true, axiosSource: source});

        let user_details_url = `${urls.API_ROOT}/api/v1/fuel-penetration/?months=${this.state.selectedValue.value}`;
        if (this.props.navigation.selectedArea && this.props.navigation.selectedArea !== -1) {
            user_details_url = user_details_url.concat(`&area_id=${this.props.navigation.selectedArea}`)
        }
        if (this.props.navigation.selectedZone && this.props.navigation.selectedZone !== -1) {
            user_details_url = user_details_url.concat(`&zone_id=${this.props.navigation.selectedZone}`)
        }
        if (this.props.navigation.selectedStation !== -1) {
            user_details_url = user_details_url.concat(`&global_code=${this.props.navigation.selectedStation}`);
        }
        axios
            .get(user_details_url, {...tokenHeader(), cancelToken: source.token})
            .then((response) => this.setState({data: response.data, xhr: false, axiosSource: null}))
            .catch(ajaxHandler);
    };


    _getColorByProduct = (product) => {
        switch (product) {
            case "Super Nafta":
                return '#DD1D21';
            case "V-Power Nafta":
                return "#00B050";
            case "V-Power Diesel":
                return "#0099FF";
        }
    };


    getFormattedData = () => {
        let data = [];
        let products = [];
        let productPerFuel = [];
        let totalData = new Array(this.state.data.length).fill(0);
        let extraTotalData = this.state.data.map(each => {
            if(each.total_volume && !isNaN(each.total_volume)){
                return each.total_volume;
            }
            return 0
        });
        let LPTotal = new Array(this.state.data.length).fill(0);
        let percentages = [];
        let monthsData = [];

        this.state.data.forEach((fuel_data) => {
            fuel_data.products.forEach((product) => {
                if (products.indexOf(product.product_display) === -1) {
                    products.push(product.product_display);
                }
            });
        });

        products.forEach((product) => {
            this.state.data.forEach((fuel_data, index) => {
                let product_find = _.find(fuel_data.products, ['product_display', product]);
                if (product_find) {
                    data.push(product_find.slp_volume);
                    extraTotalData[index] = extraTotalData[index] - product_find.slp_volume;
                    totalData[index] = fuel_data.total_volume;
                    LPTotal[index] = LPTotal[index] + product_find.slp_volume;
                } else {
                    data.push(0);
                }
                monthsData.push(months[fuel_data.month - 1]);
            });

            productPerFuel.push({name: product, color: this._getColorByProduct(product), data: data});
            data = []
        });

        productPerFuel.unshift({name: 'Total combustibles', color: '#D3D3D3', data: extraTotalData});

        totalData.forEach((total, index) => {
            percentages.push({
                m3: total,
                percentage: _.round((LPTotal[index]) * 100 / total, 1)
            })
        });

        return {data: productPerFuel, percentages, monthsData};
    };

    render() {

        let calculatedData = this.state.data ? this.getFormattedData() : false;

        return (
            <div className={"container"}>
                {calculatedData &&
                <div>
                    <div className={"subtitle-select"}>
                        <div className={"subtitle"}>Evolución de la penetración</div>
                        <Select className={"select graphics-form"}
                                values={values}
                                selectedValue={this.state.selectedValue}
                                onValueChange={this.onValueChange}/>
                    </div>
                    <div>
                        <div className={'chart'}>
                            <ColumnChart data={calculatedData.data} value={this.state.selectedValue.value}
                                         percentages={calculatedData.percentages}
                                         months={calculatedData.monthsData}/>
                        </div>
                        <Table/>
                    </div>

                </div>}
                {!calculatedData &&
                <LoadingSpinner className={'spinner'} width={50}/>
                }
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        navigation: state.navigation,
        stations: state.stations
    }
};

export default connect(mapStateToProps)(SLPPerFuel);




// WEBPACK FOOTER //
// ./src/containers/dashboard-spl/slpPerFuel/SLPPerFuel.js